import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit"
import api from "../../../api/api"
const findLatestEntitlement = (entitlements: any) => {
  const entitlementList = Object.values(entitlements)
  return entitlementList.reduce((latest: any, current: any) => {
    return new Date(current.purchase_date) > new Date(latest.purchase_date)
      ? current
      : latest
  })
}
// Types
export interface ISubscriptionDetails {
  expires_date: string
  grace_period_expires_date: string | null
  product_identifier: string
  purchase_date: string
}

export interface ISubscriptionInfo {
  auto_resume_date: string | null
  billing_issues_detected_at: string | null
  expires_date: string
  grace_period_expires_date: string | null
  is_sandbox: boolean
  original_purchase_date: string
  period_type: string
  purchase_date: string
  refunded_at: string | null
  store: string
  store_transaction_id: string
  unsubscribe_detected_at: string | null
}

export interface IPaymentInitState {
  isSubscriptionLoading: boolean
  errorSubscription: string | null
  isSubscriptionCreatingLoading: boolean
  errorCreateSubscription: string | null
  currentPovPlan: string | null
  currentPovPlanDetails: string | null
  entitlements: {
    [key: string]: ISubscriptionDetails
  }
  subscriptions: {
    [key: string]: ISubscriptionInfo
  }
  request_date: string
  request_date_ms: number
}

export interface ICreatePovSubscription {
  povPlan: string
}

// Default basic plan
const defaultBasicPlan: { [key: string]: ISubscriptionDetails } = {
  basic_pov_plan: {
    expires_date: "2025-10-26T06:58:09Z",
    grace_period_expires_date: null,
    product_identifier: "prod_QupGp5JLtQEu6v",
    purchase_date: "2024-09-26T06:58:09Z",
  },
}

// Async Thunks
export const subscribePov = createAsyncThunk(
  "subscription/povSubscription",
  async (payload: ICreatePovSubscription, { rejectWithValue }) => {
    try {
      const response = await api.payments.createPovSubscription(payload)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Something went wrong")
    }
  },
)

export const getPovSubscription = createAsyncThunk(
  "subscription/getPovSubscription",
  async (userEmail: string, { rejectWithValue }) => {
    try {
      const res = await api.payments.getPovSubscription(userEmail)
      return res.data
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Something went wrong")
    }
  },
)

// Initial State
const initialState: IPaymentInitState = {
  currentPovPlanDetails: "",
  currentPovPlan: "basic_plan",
  isSubscriptionLoading: false,
  errorSubscription: null,
  isSubscriptionCreatingLoading: false,
  errorCreateSubscription: null,
  entitlements: defaultBasicPlan,
  subscriptions: {},
  request_date: "",
  request_date_ms: 0,
}

// Slice
const paymentSubscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(subscribePov.pending, (state) => {
        state.isSubscriptionCreatingLoading = true
        state.errorCreateSubscription = null
      })
      .addCase(subscribePov.fulfilled, (state, action: PayloadAction<any>) => {
        state.isSubscriptionCreatingLoading = false
        state.errorCreateSubscription = null
        // Handle the response if needed
      })
      .addCase(subscribePov.rejected, (state, action: PayloadAction<any>) => {
        state.isSubscriptionCreatingLoading = false
        state.errorCreateSubscription = action.payload
      })
      .addCase(
        getPovSubscription.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.isSubscriptionLoading = false
          state.errorSubscription = null

          const entitlements = action.payload.subscriber?.entitlements
          const latestEntitlement: any = findLatestEntitlement(entitlements)
          console.log("latestEntitlement-latestEntitlement", latestEntitlement)

          state.subscriptions = latestEntitlement
          state.currentPovPlan = latestEntitlement?.product_identifier

          state.request_date = action.payload.request_date
          state.request_date_ms = action.payload.request_date_ms
        },
      )

    // ... rest of the code ...
  },
})

export default paymentSubscriptionSlice.reducer
